<template>
  <vs-popup
    :title="'Add venue note for ' + activeVenue.name + ' on ' + formatPopupDate()"
    @onClose="handleOnClose"
    :active.sync="showThisPopup"
    class="add-venue-note-popup">


    <div v-if="venueNote">
        <p class="mb-1 text-sm text-gray-500">Note:</p>
        <textarea v-model="venueNote.message" type="text" class="mb-2 rounded-lg w-full h-16 focus:outline-none border border-gray-200 focus:ring focus:border-blue-300 p-2"> </textarea>

    </div>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button class="mr-2"
        color="primary"
        :disabled="!validForm"
        @click="handleSaveClick"
        >Save note</vs-button
      >
      <vs-button
        type="border"
        color="primary"
        @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS} from "@/store/modules/marcom/marcom";
import moment from 'moment';
import { VenueNote } from '../../../../store/modules/marcom/data-model/venue-notes/venue-note';

export default {
  components: { },
  data() {
    return {
      showThisPopup: false,
      venueNote: undefined,
      date: undefined,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
    }),
    validForm() {
        return this.venueNote && this.venueNote.isValid();
    },

  },
  methods: {
    show(date) {
      const utcDate = moment.utc(date.format('YYYY-MM-DD')).toJSON();
      this.date = utcDate;
      this.venueNote = new VenueNote(utcDate, this.activeVenueDetails.venueDetailsId);
      this.showThisPopup = true;
    },
    async handleSaveClick() {
      try{
        this.$vs.loading();

        await this.$store.dispatch('marcom/' + VENUE_ACTIONS.AddVenueNote, this.venueNote);

        this.handleOnClose();
      }
      catch(err) {
        console.error(err);
        throw err;
      }
      finally{
        this.$vs.loading.close();
      }
    },
    handleOnClose() {
      this.venueNote = undefined;
      this.showThisPopup = false;
    },
    formatPopupDate() {
      let noteMoment =  moment.utc(this.date);
      if(!noteMoment.isValid)
        return;
      return noteMoment.format('DD-MM-YYYY');
    }
  },
};
</script>

<style lang="scss" scoped>

.add-venue-note-popup::v-deep .vs-popup {
  width: 1080px;
}
</style>
